<router-outlet></router-outlet>
<ng-container *ngIf="isBrowser">
  <tm-info-alert [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.alertTitle' | translate" [modalConfig]="alertModalConfig"></tm-info-alert>
  <tm-info-confirm [okBtnLabel]="'modal.ok' | translate" [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.corfirmTitle' | translate" [modalConfig]="alertModalConfig"></tm-info-confirm>
  <tm-error-alert [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.errorTitle' | translate" copyBtnLabel="複製到剪貼簿" [modalConfig]="alertModalConfig"></tm-error-alert>
  <tm-indeterminate-progress-bar></tm-indeterminate-progress-bar>
</ng-container>

